const staticUrl = {
    "BASE_URL": "https://staging.examsbook.com/",
    "ERROR_URL": "img/test-series-error.jpg",
    "ERROR_USER_IMAGE": "/img/user.png",
    "PRIVACY_POLICY": "https://www.examsbook.com/privacy-policy",
    "TERMS_CONDITION": "https://www.examsbook.com/terms-conditions",
    "PLAY_STORE_LINK": "https://play.google.com/store/apps/details?id=com.examsbook.myapp",
    "APP_STORE_LINK": "https://apps.apple.com/us/app/examsbook-a-learning-app/id1498498125"
};
export default staticUrl;
